module.exports = __webpack_public_path__ + "img/کارت-ویزیت-سلفون-براق.e0ecdfaf.png";